import React, { Component } from 'react';
import axios from 'axios';
import theme from "../../../Theme/theme"
import Spinner from '../../../components/LoadingSpinner'
import { API_URL, ERROR_HANDLE, GYM_TAG_UNIQUE_ID } from '../../../config/constants';
import "./style.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import GymListModal from './Modals/gymListModal';
import { submit } from '../../../common/Utils'

const DAY_COUNT = 7;
const OVERRIDE_TEXT = "Are you sure you want to save override";
const DISCARD_ALERT_TEXT = "You have unsaved changes on this page. Do you want to discard your changes?";
const DISCOUNT_KEY = "discount";
const IS_SET_BY_ADMIN_KEY = "isSetByAdmin";
const TABLE_HEADER_TITLE = "Day \\ Hour";
const UNIVERSAL_PANEL = "UNIVERSAL \n CONTROL \n\n PANEL";
const SET_DISCOUNT = "Set Discount :";
const SAVE_STANDARD = "Save Standard";
const DISCARD_CHANGES = "Discard Changes";
const INDIVIDUAL_GYM = "ADJUST INDIVIDUAL GYMS";
const BACK_TO_GYM_LIST = "BACK TO GYM LIST";
const OVERRIDE_ALL = "OVERRIDE ALL";
const SAVE_OVERRIDE = "SAVE OVERRIDE";
const CLOSE_TEXT = "CLOSE"
const UNIVERSAL_PANEL_IMAGE = require('../../../assets/images/dynamicPricing/control_icon.png');
const WEIGHT_IMAGE = require('../../../assets/images/dynamicPricing/weight.png');
const TRIANGLE_BACK_IMAGE = require('../../../assets/images/dynamicPricing/triangle_back.png');
const TRIANGLE_DOWN_IMAGE = require('../../../assets/images/dynamicPricing/triangle_down.png');
const buttonList = {
    NONE_SELECTED: 0,
    INDIVIDUAL_GYM_BUTTON: 1,
    SAVE_STANDARD_BUTTON: 2,
    OVERRIDE_ALL_BUTTON: 3,
    SAVE_OVERRIDE_BUTTON: 4
}
const DISCOUNT_PERCENTAGE = [0, 10, 15, 20, 25, 30, 40, 50];

class DynamicPricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicPrice: {},
            selectedDay: [],
            selectedTime: [],
            selectedDiscount: -1,
            selectedGym: {
                gym_id: "",
                gym_name: ""
            },
            isLoading: true,
            showGymListPopup: false
        };
        this.gymsList = [];
        this.dynamicPriceBackup = {} //this state used for discard functionality, will hold the array received from API
        this.selectedThemeColor = { backgroundColor: theme.color.lightPrimaryBlue }
        this.intersectThemeColor = {
            backgroundColor: theme.color.primaryBlue,
            color: theme.color.white,
            fontFamily: theme.font.avenirBlackOblique
        }
        this.buttonSelected = buttonList.NONE_SELECTED;
    };

    componentDidMount() {
        this.getAdminDiscount();
    }

    getAdminDiscount() {
        const access_token = localStorage.getItem('access_token');
        axios
            .get(`${API_URL}/admin/discounts`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                if (!res.error) {
                    this.setState({
                        dynamicPrice: res.data
                    }, () => {
                        //Deep copy the dynamic price to restore the values, it is used for discard changes functionality
                        this.dynamicPriceBackup = this.state.dynamicPrice ? JSON.parse(JSON.stringify(this.state.dynamicPrice)) : {}
                        this.updateTheme();
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    getGymDiscount() {
        const access_token = localStorage.getItem('access_token');
        const url = this.state.selectedGym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? "tag/discounts/" : "gyms/"
        //Parse the gymTagId to int which will eliminate the "Tag" keyword from the gym_id, then append with "" to convert to string since backend is expecting this as string.
        axios
            .get(`${API_URL}/admin/${url}${parseInt(this.state.selectedGym.gym_id) + ""}`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                if (!res.error) {
                    const jsonData = res.data;
                    this.setState({
                        dynamicPrice: jsonData[0].timeslot_discount
                    }, () => {
                        //Deep copy the dynamic price to restore the values, it is used for discard changes functionality
                        this.dynamicPriceBackup = this.state.dynamicPrice ? JSON.parse(JSON.stringify(this.state.dynamicPrice)) : {}
                        this.updateTheme();
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    saveGymDiscount(updatedDiscount) {
        const access_token = localStorage.getItem('access_token');
        const url = this.state.selectedGym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? "tag/discounts/" : "gym/discounts/"
        //Parse the gymTagId to int which will eliminate the "Tag" keyword from the gym_id, then append with "" to convert to string since backend is expecting this as string.
        axios
            .post(`${API_URL}/admin/${url}${parseInt(this.state.selectedGym.gym_id) + ""}`, {
                updatedDiscount: updatedDiscount,
                adminUser: "FlexitAdmin"
            }, {
                headers: {
                    'x-access-token': access_token
                }
            }
            )
            .then(res => {
                if (!res.error) {
                    //success
                    this.getGymDiscount();
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    saveAdminDiscount(updatedDiscount) {
        const access_token = localStorage.getItem('access_token');
        // console.log("getUpdatedDiscount() is " + JSON.stringify(this.getUpdatedDiscount()));
        axios
            .post(`${API_URL}/admin/discounts`, {
                updatedDiscount: updatedDiscount,
                isOverride: this.buttonSelected === buttonList.OVERRIDE_ALL_BUTTON ? true : false,
                adminUser: "FlexitAdmin"
            }, {
                headers: {
                    'x-access-token': access_token
                }
            }
            )
            .then(res => {
                if (!res.error) {
                    //success
                    this.getAdminDiscount()
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    getUpdatedDiscount() {
        let updatedDiscount = {}
        this.state.dynamicPrice && Object.keys(this.state.dynamicPrice).map((key, index) => {
            let updatedDiscountOfDay = {}
            for (let index = 0; index <= 23; index++) {
                const dynamicPriceOfDay = this.state.dynamicPrice[key];
                if (this.isBothDayTimeSelected(key.toUpperCase(), index, this.state.selectedDiscount)) {
                    updatedDiscountOfDay[index] = {
                        [DISCOUNT_KEY]: this.getDiscountOfTime(dynamicPriceOfDay, index)
                    }
                }
            }
            if (Object.keys(updatedDiscountOfDay).length > 0) {
                updatedDiscount[key] = updatedDiscountOfDay
            }
        })
        return updatedDiscount
    }

    /**
     * @description this is the props method gets handled from gym list component to avoid gyms API call every time.
     * @param gymsList - the gymsList value will receive from gym list component
     */
    updateGymsList = (gymsList) => {
        this.gymsList = gymsList
    }

    /**
     * @description this is the props method gets handled from gym list
     * @param gym - the gym value will receive from gym list component
     */
    updateSelectedGym = (gym) => {
        this.setState({
            selectedGym: {
                gym_id: gym.gym_id,
                gym_name: gym.gym_name
            },
            showGymListPopup: false
        }, () => {
            this.getGymDiscount()
            this.resetTableState(() => { })
        })
    }

    resetTableState = (callback) => {
        this.setState({
            selectedDay: [],
            selectedTime: [],
            selectedDiscount: -1
        }, () => {
            callback()
        })
    }

    updateTheme() {
        this.selectedThemeColor = { backgroundColor: this.state.selectedGym.gym_id.length > 0 ? theme.color.lightPrimaryPink : theme.color.lightPrimaryBlue }
        this.intersectThemeColor = {
            backgroundColor: this.state.selectedGym.gym_id.length > 0 ? theme.color.primaryPink : theme.color.primaryBlue,
            color: theme.color.white,
            fontFamily: theme.font.avenirBlackOblique
        }
    }

    updateDynamicPriceArray(day, time, discount) {
        this.isBothDayTimeSelected(day, time) && discount >= 0 &&
            Object.keys(this.state.dynamicPrice).map((key) => {
                let dynamicPrice = this.state.dynamicPrice;
                let dynamicPriceOfDay = dynamicPrice[key];
                if (day.toUpperCase() === key.toUpperCase() && this.getDiscountOfTime(dynamicPriceOfDay, time) != discount) {
                    dynamicPriceOfDay[time] = {
                        ...dynamicPriceOfDay[time],
                        "discount": discount
                    }
                    this.setState({
                        dynamicPrice
                    })
                }
            })
    }

    updateSelectedDay(day) {
        let selectedDayArray = this.state.selectedDay;
        const index = selectedDayArray.indexOf(day);
        (index === -1) ? selectedDayArray.push(day) : selectedDayArray.splice(index, 1);
        return selectedDayArray;
    }

    updateSelectedTime(time) {
        let selectedTimeArray = this.state.selectedTime;
        const index = selectedTimeArray.indexOf(time);
        (index === -1) ? selectedTimeArray.push(time) : selectedTimeArray.splice(index, 1);
        return selectedTimeArray;
    }

    isDaySelected(day) {
        return (this.state.selectedDay.indexOf(day) === -1) ? false : true
    }

    isTimeSelected(time) {
        return (this.state.selectedTime.indexOf(time) === -1) ? false : true
    }

    isBothDayTimeSelected(day, time) {
        return this.isTimeSelected(time) && this.isDaySelected(day) ? true : false
    }

    getDiscountOfTime(dynamicValueOfDay, time) {
        let discountOfTime = dynamicValueOfDay[time] === -1 ? null : dynamicValueOfDay[time];
        return discountOfTime ? discountOfTime[DISCOUNT_KEY] : 0
    }

    getOverrideDiscountOfTime(dynamicValueOfDay, time) {
        let overrideDiscountOfTime = dynamicValueOfDay[time] === -1 ? null : dynamicValueOfDay[time];
        return overrideDiscountOfTime ? overrideDiscountOfTime[IS_SET_BY_ADMIN_KEY] : false
    }

    renderControlPanel() {
        const panelTextStyle = this.state.selectedGym.gym_id.length > 0 ? { ...style.panelText, ...{ color: theme.color.white } } : style.panelText
        return (
            <div style={{ ...style.panelWrapper, ...style.flexAlignSpaceBetween, ...{ backgroundColor: this.state.selectedGym.gym_id.length > 0 ? theme.color.primaryBlue : theme.color.borderGrey } }}>
                <div style={{ backgroundColor: this.state.selectedGym.gym_id.length > 0 ? theme.color.borderGrey : theme.color.primaryBlue, width: 23, height: "100%" }} />
                {
                    this.state.selectedGym.gym_id.length > 0 ?
                        <div style={{ flexDirection: "column" }}>
                            <img src={WEIGHT_IMAGE} style={{ marginBottom: 50, height: 53, width: 124 }} />
                            <div style={panelTextStyle}>{this.state.selectedGym.gym_name}</div>
                        </div> :
                        <div style={{ flexDirection: "column" }}>
                            <div style={panelTextStyle}>{UNIVERSAL_PANEL}</div>
                            <img src={UNIVERSAL_PANEL_IMAGE} style={{ height: 80, width: 73 }} />
                        </div>
                }
            </div >
        );
    }

    renderDiscountButtons() {
        let discountButtons = [];
        DISCOUNT_PERCENTAGE.forEach((discount) => {
            const selectedStyle = this.state.selectedDiscount === discount ? { ...style.discountButton, ...this.intersectThemeColor } : style.discountButton
            discountButtons.push(<div
                key={"discount" + discount}
                style={{ ...style.buttonStyle, ...selectedStyle }}
                onClick={() => {
                    this.setState({
                        selectedDiscount: discount
                    })
                }}> {discount + "%"}</div>)
        })
        return (
            <div style={{ ...style.buttonStyle, ...style.discountContainer }}>
                <div style={{ marginRight: 20, marginLeft: 20 }}>{SET_DISCOUNT}</div>
                {discountButtons}
            </div>
        );
    }

    renderGymNavigationButton = () => {
        return (
            this.state.selectedGym.gym_id.length > 0 ?
                <div style={{ ...style.buttonStyle, ...style.individualGymButton, ...{ display: "flex", justifyContent: "center" } }}
                    onClick={() => {
                        this.setState({ selectedGym: { gym_id: "", gym_name: "" } }, () => this.resetTableState(() => { }))
                        this.getAdminDiscount()
                    }}>
                    <img style={{ width: 30, height: 26, marginTop: 17, marginRight: 30 }} src={TRIANGLE_BACK_IMAGE} />{BACK_TO_GYM_LIST}
                </div> :
                <div style={{ ...style.buttonStyle, ...style.individualGymButton, ...{ display: "flex", justifyContent: "center" } }}
                    onClick={() => {
                        this.buttonSelected = buttonList.INDIVIDUAL_GYM_BUTTON
                        this.setState({ showGymListPopup: true })
                    }}>
                    {INDIVIDUAL_GYM}<img style={{ width: 37, height: 26, marginTop: 17, marginLeft: 15 }} src={TRIANGLE_DOWN_IMAGE} />
                </div>
        );
    }

    renderButtonComponent() {
        return (
            <div style={{ display: "flex", flexDirection: "column", width: 1195 }}>
                <div style={{ ...style.flexAlignSpaceBetween, ...{ marginBottom: 33 } }}>
                    {this.renderDiscountButtons()}
                    {
                        this.state.selectedGym.gym_id.length === 0 && <div style={{ ...style.buttonStyle, ...style.saveStandardButton }} onClick={() => {
                            if (this.state.selectedDay.length > 0 && this.state.selectedTime.length > 0) {
                                this.buttonSelected = buttonList.SAVE_STANDARD_BUTTON
                                this.setState({ showGymListPopup: true })
                            }
                        }}>{SAVE_STANDARD}</div>
                    }
                </div>
                <div style={style.flexAlignSpaceBetween}>
                    <div style={{ ...style.buttonStyle, ...style.discardButton }}
                        onClick={() => {
                            if (this.state.selectedDay.length > 0 || this.state.selectedTime.length > 0) {
                                submit(DISCARD_ALERT_TEXT, () => {
                                    this.resetTableState(() => {
                                        //Deep copy the dynamic price to restore the values
                                        this.setState({ dynamicPrice: JSON.parse(JSON.stringify(this.dynamicPriceBackup)) })
                                    })
                                })
                            }
                        }}>{DISCARD_CHANGES}</div>
                    {this.renderGymNavigationButton()}
                    <div style={{ ...style.buttonStyle, ...style.overrideAllButton, ...this.intersectThemeColor }} onClick={() => {
                        if (this.state.selectedDay.length > 0 && this.state.selectedTime.length > 0) {
                            if (this.state.selectedGym.gym_id.length > 0) {
                                this.buttonSelected = buttonList.SAVE_OVERRIDE_BUTTON
                                submit(OVERRIDE_TEXT, () => {
                                    this.buttonAction()
                                })
                            } else {
                                this.buttonSelected = buttonList.OVERRIDE_ALL_BUTTON
                                this.setState({ showGymListPopup: true })
                            }
                        }
                    }}>{this.state.selectedGym.gym_id.length > 0 ? SAVE_OVERRIDE : OVERRIDE_ALL}</div>
                </div>
            </div >
        );
    }

    renderTableHeader() {
        let timeSlot = [];
        for (let index = 0; index <= 23; index++) {
            index === 0 && timeSlot.push(
                <th key={"timeSlotTitle" + index} style={{
                    ...style.timeSlotHeader, ...style.columnHeaderSize, ...{ fontSize: 18 }
                }
                }> {TABLE_HEADER_TITLE}</th >)
            const selectedStyle = this.isTimeSelected(index) ? { ...style.timeSlotHeader, ...this.intersectThemeColor } : style.timeSlotHeader
            timeSlot.push(<th
                key={"timeSlot" + index}
                style={style.rowValueSize}
                onClick={() => {
                    this.setState({
                        selectedTime: this.updateSelectedTime(index)
                    })
                }}> <div className="timeSlot-Header" style={selectedStyle}>{(index < 10) ? '0' + index.toString() + ":00" : index.toString() + ":00"}</div></th >)
        }
        return (
            <tr>
                {timeSlot}
            </tr>
        );
    }

    renderTableBody() {
        return Object.keys(this.state.dynamicPrice).map((key, index) => {
            let dynamicPriceArray = [];
            const day = key.toUpperCase();
            for (let index = 0; index <= 23; index++) {
                const dynamicPriceOfDay = this.state.dynamicPrice[key];
                const discountPrice = this.getDiscountOfTime(dynamicPriceOfDay, index);
                const selectedStyle = this.isDaySelected(day) ? { ...style.daySlotHeader, ...this.intersectThemeColor } : style.daySlotHeader
                {
                    index === 0 && dynamicPriceArray.push(<td
                        key={"dynamicPriceTitle" + index + key}
                        style={{ ...selectedStyle, ...style.columnHeaderSize }}
                        onClick={() => {
                            this.setState({
                                selectedDay: this.updateSelectedDay(day)
                            })
                        }}>{key.toUpperCase()}</td>)
                }
                //Background style has been set as per the below priority 
                if (this.isBothDayTimeSelected(day, index, this.state.selectedDiscount)) {
                    selectedStyle = { ...style.dynamicValues, ...this.intersectThemeColor }
                } else if (this.state.selectedGym.gym_id.length > 0 && this.getOverrideDiscountOfTime(dynamicPriceOfDay, index)) {
                    //This is the primary blue override style applied for the individual gym
                    const overrideStyle = { backgroundColor: theme.color.primaryBlue }
                    selectedStyle = { ...style.dynamicValues, ...overrideStyle }
                } else if (discountPrice > 0) {
                    const discountStyle = { backgroundColor: this.state.selectedGym.gym_id.length > 0 ? theme.color.primaryPink : theme.color.primaryBlue }
                    selectedStyle = { ...style.dynamicValues, ...discountStyle }
                } else {
                    selectedStyle = this.isTimeSelected(index) || this.isDaySelected(day) ? { ...style.dynamicValues, ...this.selectedThemeColor } : style.dynamicValues
                }
                dynamicPriceArray.push(<td
                    key={"dynamicPrice" + index + key}
                    style={{ ...selectedStyle, ...style.rowValueSize }}
                    onClick={() => {
                        this.resetTableState(() => {
                            this.setState({
                                selectedTime: this.updateSelectedTime(index),
                                selectedDay: this.updateSelectedDay(day)
                            })
                        })
                    }}> {discountPrice}</td>)
                //update dynamic price array if any changes or update required.
                this.updateDynamicPriceArray(day, index, this.state.selectedDiscount);
            }
            return (
                <tr key={"tableRow" + key} >
                    {dynamicPriceArray}
                </tr >
            )
        });
    }

    buttonAction() {
        switch (this.buttonSelected) {
            case buttonList.SAVE_STANDARD_BUTTON:
            case buttonList.OVERRIDE_ALL_BUTTON:
                const updatedAdminDiscount = this.getUpdatedDiscount()
                Object.keys(updatedAdminDiscount).length > 0 && this.saveAdminDiscount(updatedAdminDiscount)
                break;
            case buttonList.SAVE_OVERRIDE_BUTTON:
                const updatedGymDiscount = this.getUpdatedDiscount()
                Object.keys(updatedGymDiscount).length > 0 && this.saveGymDiscount(updatedGymDiscount);
                break;
            case buttonList.INDIVIDUAL_GYM_BUTTON:

        }
        this.buttonSelected = buttonList.NONE_SELECTED
        this.setState({ showGymListPopup: false }, () => {
            this.buttonSelected != buttonList.INDIVIDUAL_GYM_BUTTON && this.resetTableState(() => { })
        })
    }

    getButtonTitle() {
        switch (this.buttonSelected) {
            case buttonList.SAVE_STANDARD_BUTTON:
                return SAVE_STANDARD
            case buttonList.OVERRIDE_ALL_BUTTON:
                return OVERRIDE_ALL
            case buttonList.SAVE_OVERRIDE_BUTTON:
                return SAVE_OVERRIDE
            default:
                return CLOSE_TEXT
        }
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                this.state.dynamicPrice && Object.keys(this.state.dynamicPrice).length === DAY_COUNT ?
                    <div style={style.wrapper}>
                        <div style={{ display: "flex" }}>
                            <div style={style.tableWrapper}>
                                <div style={style.tableContainer}>
                                    <div style={style.borderContainer}>
                                        <table>
                                            <thead>
                                                {this.renderTableHeader()}
                                            </thead>
                                            <tbody>
                                                {this.renderTableBody()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {this.renderControlPanel()}
                        </div>
                        {this.renderButtonComponent()}
                        {
                            this.state.showGymListPopup &&
                            <GymListModal
                                gymsList={this.gymsList}
                                updateGymsList={(gymsList) => this.updateGymsList(gymsList)}
                                updateSelectedGym={(gym) => this.updateSelectedGym(gym)}
                                buttonSelected={this.buttonSelected}
                                buttonTitle={this.getButtonTitle()}
                                buttonAction={() => this.buttonAction()}
                                close={() => this.setState({ showGymListPopup: false })}
                                updatedDiscount={this.getUpdatedDiscount()} />
                        }
                    </div> : <div style={style.wrapper}> Something went wrong...Please reload the page </div>
        );
    }
}

const style = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        paddingBottom: '75px',
        flexDirection: 'column',
        alignItems: 'center',
    },
    flexAlignSpaceBetween: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center'
    },
    tableWrapper: {
        alignItems: 'center',
        borderRadius: 15,
        backgroundColor: theme.color.textLightWhite,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        padding: 12,
        paddingBottom: 37,
        zIndex: 1
    },
    panelWrapper: {
        borderRadius: 15,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        marginTop: 40,
        marginBottom: 40,
        marginLeft: -10,
        height: 430,
        width: 200,
        paddingLeft: 32,
        paddingRight: 32
    },
    tableContainer: {
        paddingTop: 27,
        paddingBottom: 27,
        paddingLeft: 22,
        paddingRight: 22,
        borderRadius: 15,
        boxShadow: "0 0 10px 0 inset " + theme.color.lightShadowColor
    },
    borderContainer: {
        paddingRight: 3,
        paddingBottom: 3,
        borderRight: "12px solid black",
        borderBottom: "12px solid black"
    },
    timeSlotHeader: {
        fontSize: 13,
        fontFamily: theme.font.avenirMediumOblique,
        color: theme.color.textLightWhite,
        textAlign: 'center',
        backgroundColor: theme.color.thickGrey
    },
    daySlotHeader: {
        fontSize: 15,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.textLightWhite,
        textAlign: 'center',
        border: "1px solid " + theme.color.borderGrey,
        backgroundColor: theme.color.grey
    },
    dynamicValues: {
        fontSize: 16,
        fontFamily: theme.font.avenirLightOblique,
        color: theme.color.thickGrey,
        textAlign: 'center',
        border: "1px solid " + theme.color.grey,
        backgroundColor: theme.color.textLightWhite
    },
    columnHeaderSize: {
        width: 100,
        height: 45,
    },
    rowValueSize: {
        maxWidth: 30,
        height: 45,
        padding: -10
    },
    panelText: {
        fontSize: 30,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        whiteSpace: "pre-wrap",
        marginBottom: 45,
        width: 150
    },
    buttonStyle: {
        textAlign: "center",
        lineHeight: "60px",
        borderRadius: 10,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        fontSize: 28,
        backgroundColor: theme.color.textLightWhite,
        color: theme.color.thickGrey,
        fontFamily: theme.font.avenirMediumOblique,
    },
    discountContainer: {
        display: "flex",
        width: 940,
        fontSize: 22,
        backgroundColor: theme.color.grey,
        color: theme.color.mediumGrey,
        lineHeight: "70px",
        marginTop: -10
    },
    discountButton: {
        fontSize: 26,
        zIndex: 2,
        marginRight: 20,
        height: 60,
        width: 75,
        fontFamily: theme.font.avenirMedium
    },
    saveStandardButton: {
        width: 230,
        fontFamily: theme.font.avenirBlackOblique,
    },
    discardButton: {
        width: 230,
        fontSize: 26,
    },
    individualGymButton: {
        width: 540,
        backgroundColor: theme.color.grey,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.textLightWhite,
    },
    overrideAllButton: {
        width: 230,
        fontSize: 26,
        backgroundColor: theme.color.red,
        fontFamily: theme.font.avenirBlack,
        color: theme.color.textLightWhite,
    }
}

export default DynamicPricing;
